import { render, staticRenderFns } from "./RewardExtractTab.vue?vue&type=template&id=1915a4f5&scoped=true&"
import script from "./RewardExtractTab.vue?vue&type=script&lang=js&"
export * from "./RewardExtractTab.vue?vue&type=script&lang=js&"
import style0 from "./RewardExtractTab.vue?vue&type=style&index=0&id=1915a4f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1915a4f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1915a4f5')) {
      api.createRecord('1915a4f5', component.options)
    } else {
      api.reload('1915a4f5', component.options)
    }
    module.hot.accept("./RewardExtractTab.vue?vue&type=template&id=1915a4f5&scoped=true&", function () {
      api.rerender('1915a4f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/clients/components/client-maintain-tabs/RewardExtractTab.vue"
export default component.exports